import * as React from "react";
import { useContext, useState } from "react";
import { Box, Button, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import WarningSign from "../../../Assets/warning.png";
import { DashboardInfoContext, DashboardInfoPayload } from "../../../Context/dashboardContext";
import GlobalPopupStyles from "./globalPopUpStyles";
import ThirdPartySubmitConfirmationContent
    from "../../ThirdPartyQuestionnaire/thirdPartySubmitConfirmationContent/thirdPartySubmitConfirmationContent";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const {
        children,
        onClose,
        ...other
    } = props;

    return (
        <DialogTitle
            sx={{
                m: 0,
                p: 2,
            }}
            {...other}
        >
            {children}
            {
                onClose ?
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    : null
            }
        </DialogTitle>
    );
};

interface IGlobalPopupProps {
    setflagPopUp: (value: boolean) => void;
    flagPopUp: boolean;
    heading: string;
    section: string;
    message?: string;
    HandleLnidThreePsChange?: () => void;
    Content?: React.ReactNode;
}

function GlobalPopUp(props: IGlobalPopupProps) {

    const {
        Content,
        flagPopUp,
        heading,
        message,
        setflagPopUp,
        section,
        HandleLnidThreePsChange
    } = props;

    const { currentActiveEnvironment } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const {
        textStyle,
        close_button,
        save_button,
        TitleBar,
        lastSection,
        actionBox,
        dialogOuter,
        dividers,
        selectStyle,
        inputLabelStyle,
        warningImage
    } = GlobalPopupStyles().classes;

    const [environment, setEnvironment] = useState(currentActiveEnvironment);

    const CloseDialog = () => {
        setflagPopUp(!flagPopUp);
    };

    const ChangeEnvironment = (e: any) => {
        setEnvironment(e.target.value);
    }

    const SaveChangedEnvironment = () => {
        CloseDialog();
        if (environment === "Development") {
            window.location.replace("https://devportal.instabrain-dev.io/insights");
        }
        else if (environment === "Staging") {
            window.location.replace("https://devportal.instabrainstage.io/insights");
        }
    };

    return (
        <div className="Main">
            <BootstrapDialog
                className={dialogOuter}
                onClose={CloseDialog}
                aria-labelledby="customized-dialog-title"
                open={flagPopUp}
            >
                <Box className={TitleBar}>
                    <BootstrapDialogTitle id="customized-dialog-title" onClose={CloseDialog}>
                        {heading}
                    </BootstrapDialogTitle>
                </Box>
                {section === "changeLNID" && (
                    <DialogContent className={dividers}>
                        <Grid container direction="column">
                            <Grid item>
                                <Grid container justifyContent="center" direction="column" alignItems="center">
                                    <Grid item>
                                        <img alt="warning sign" src={WarningSign} className={warningImage} />
                                    </Grid>
                                    <Grid item>
                                        <Typography className={textStyle}>
                                            {message}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                )}

                {section === "changeEnvironment" && (
                    <DialogContent className={dividers}>
                        <Grid container direction="column">
                            <Grid item>
                                <Grid container justifyContent="center" direction="column" alignItems="center">
                                    <Grid item>
                                        <InputLabel className={inputLabelStyle}>
                                            Change Environment
                                        </InputLabel>
                                        <Select
                                            className={selectStyle}
                                            value={environment}
                                            onChange={ChangeEnvironment}
                                            inputProps={{ "aria-label": "Without label" }}
                                        >
                                            {
                                                environment === "Production" ?
                                                    <MenuItem value={"Production"}>Production</MenuItem> :
                                                    [
                                                        <MenuItem key={"Development"} value={"Development"}>Development</MenuItem>,
                                                        <MenuItem key={"Staging"} value={"Staging"}>Staging</MenuItem>
                                                    ]
                                            }
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                )}

                {
                    section === "applicationAnalysisResultUpdation" && Content
                }

                {
                    section === "confirmSubmit" && <ThirdPartySubmitConfirmationContent CloseDialog={CloseDialog} />
                }

                {section === "changeLNID" && (
                    <DialogActions className={actionBox}>
                        <Grid container direction="row" justifyContent="center" marginBottom={"36px"}>
                            <Grid item className={lastSection}>
                                <Button className={close_button} onClick={HandleLnidThreePsChange} disableRipple>
                                    Yes
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button className={save_button} onClick={CloseDialog} disableRipple>
                                    No
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                )}

                {section === "changeEnvironment" && (
                    <DialogActions className={actionBox}>
                        <Grid container direction="row" justifyContent="center" marginBottom={"36px"}>
                            <Grid item className={lastSection}>
                                <Button className={close_button} disableRipple onClick={CloseDialog}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button className={save_button} disableRipple onClick={SaveChangedEnvironment}>
                                    Save Changes
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                )}
            </BootstrapDialog>
        </div>
    );
}

export default React.memo(GlobalPopUp);